import { Inject, Pipe, PipeTransform } from '@angular/core';
import { ENVIRONMENT, Environment } from '@domains';

@Pipe({
  name: 'resolveUrl',
  standalone: true,
})
export class ResolveUrlPipe implements PipeTransform {
  constructor(@Inject(ENVIRONMENT) private environment: Environment) {}

  transform(value: string | null | undefined): string {
    if (!value) return '';
    if (value.startsWith('http')) return value;
    return this.environment.urls.baseUrl + value;
  }
}
